import api from '../api/api';
import uploadAPI from '../api/uploadAPI';

async function getUploadLink({ account, digitalKey, fileName, contentType }) {
  console.log(
    '🚀 ~ file: useUpload.js ~ line 5 ~ getUploadLink ~ digitalKey',
    digitalKey
  );
  const unlockable = await uploadAPI.post(`/unlock/addlink/${account}`, {
    digitalKey,
    fileName,
    contentType,
  });
  return unlockable.data;
}
async function getCopyUploadLink(unlockableLink) {
  const unlockable = await uploadAPI.post(`/unlock/copy/${unlockableLink}`);
  return unlockable.data;
}
async function updataUnlock(unlockID, tokenID, contractAddress, type) {
  uploadAPI
    .put('/unlock/' + unlockID, { tokenID, contractAddress, type })
    .then((res) => console.log('Put token ID in unlockable data complete...'));
}
async function pinFileIPFS(
  name,
  cover,
  lockable,
  sorce = 'tmp',
  isUsersPinata = 'main'
) {
  let hashFile, localPath, tempName;
  if (lockable) {
    hashFile = await uploadAPI.post('/unlock/ipfs-upload', { key: name });
  } else {
    if (name.includes('https://')) {
      localPath = await api.post('/tmp-upload/link', { fileLink: name });
      hashFile = await api.post(`/pinFile/${isUsersPinata}`, {
        name: localPath.data,
        withTumb: true,
        sorce,
      });
    } else {
      hashFile = await api.post(`/pinFile/${isUsersPinata}`, {
        name,
        cover,
        withTumb: true,
        sorce,
      });
    }
    localPath && localPath.data ? (tempName = localPath.data) : (tempName = '');
  }
  console.log('🚀 Front resived File hash!!!: ', hashFile.data);
  return lockable
    ? hashFile.data
    : {
        imageHash: hashFile.data.hashFile,
        coverHash: hashFile.data.hashCover,
        thumbnail: hashFile.data.thumbName,
        tempName,
      };
}
async function pinJSONIPFS(metadata) {
  const hashMetadata = await api.post('/pinJSON', metadata);
  console.log('🚀 Front resived JSON hash: ', hashMetadata.data);
  return hashMetadata.data;
}

async function pinJSONArr(address, items) {
  const hashMetadata = await api.post("/pinJsonObjArr", { address, items });

  return hashMetadata.data.hash;
}

export {
  getUploadLink,
  getCopyUploadLink,
  updataUnlock,
  pinFileIPFS,
  pinJSONIPFS,
  pinJSONArr,
};
